export default __webpack_public_path__ + "static/media/company-details.4f90e7ee.png";